<template>
    <section class="wrap">
        <div class="mobile_wrap">
            <div class="qr_wrap">
              <div class="qr_code">
                <qrcode-vue :value="qrCodeData" :size="qrCodeSize"/>
              </div>
            </div>
            <loading v-show="loading"/>
        </div>
    </section>
</template>

<script>
import { ref, onMounted } from 'vue';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';
import QrcodeVue from 'qrcode.vue';
import client from '../client/client';
import axios from 'axios';


export default {
  name: "QRcode",
  components: {
    QrcodeVue,
  },
  data() {
    const route = useRoute()
    const { query } = route;
    return {
        loading: false,
        query : query,
        qrCodeData : '',
        qrCodeSize : 200,
    } 
  },
  methods : {
    async update() {
      const route = useRoute();
      const {query} = route;
      client.updateToken(query);
      const baseUrl = process.env.VUE_APP_API_BASE_URL;
      const id = query.id;

      //qr생성
      let result = await client.post(`/qr/create`, {
          fridge_id : id,
      })
      .then((res) => {
        let qr_id = res.data.id;
        let fridge_id = res.data.fridge_id;
        let member_no = res.data.member_no;
       
        this.qrCodeData = baseUrl + `?qr_id=${qr_id}&&member_no=${member_no}`; 
        
      })
      .catch((error) => {
        console.error('Error :', error);
      })
      
    },
  },
  async mounted() {
    this.update();
  }
};
</script>

<style lang="scss" scoped>
#app, .wrap, .mobile_wrap {
  height:100%;
}

//디자인 나온후 작업예정
.qr_wrap {
  position:relative;
  height: 100vh; /* 뷰포트 높이 */
  height: -webkit-fill-available; /* iOS에서 가용 가능한 높이 */
  height: 100%; /* 부모 요소가 가득 찰 경우를 대비한 fallback */
  // margin-top:88.0556vw;
  // height:calc(100vh - 12.7778vw);
  // margin:109.5833vw auto 0;
  text-align:center;
}
.qr_code {
  position: absolute;
  top:50%;
  left:50%;
  transform:translate(-50%, -50%);
}
</style>